import axios from 'axios'
import formatter from './formatter'
import { profile } from '../stores/storages/ProfileStorage' 

const PREFIX = '[API]'

class API {
  request = async ({ method, path, host, data, options = {} }) => {
    const DefaultOptions = {
      fullPath: false,
      customKey: profile.authAPI.token,
      decrypt: true,
    }

    host = host.replace('http://', 'https://')
    window.logger(`${PREFIX}|Call API|path=${path}`)
    const opts = { ...DefaultOptions, ...options }
    const { fullPath, customKey, decrypt } = opts
    const url = fullPath ? path : `${host}${path}`

    try {
      const response = await axios[method](url, data, opts)

      if (response.data) {
        if (Number(response.data.code) === 401) {
          window.logger(`${PREFIX}|Call API|Code=401`)
          return null
        }

        if (Number(response.data.code) === 200 || Number(response.data.code) === 0 || Number(response.data.errorCode) === 0) {
          if (decrypt) {
            const decrypted = response.data.data && formatter.xxteaDecrypt(response.data.data, customKey)
            if (decrypted) {
              delete response.data.data
              window.logger(`${PREFIX}|Call decrypt API`, JSON.stringify(response.data))
              return Object.assign(JSON.parse(decrypted), response.data)
            }
          }
          window.logger(`${PREFIX}|Call API`, JSON.stringify(response.data))
          return response.data
        }
        if (Number(response.data.code) === 99 || Number(response.data.code) === 423) {
          return response.data
        }
      } else {
        window.logger(`${PREFIX}|Response Data null|${response}`)
      }
    } catch (err) {
      window.logger(`Call API error|${url}|${err.stack}`)
    }

    return null
  }
}

export default new API()
